import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable, take, tap } from 'rxjs';
import { SettingsTimeRecordingApiService } from '@data-terminal/feature-settings/services/settings-time-recording-api/settings-time-recording-api.service';
import {
    TimeRecordingSettings,
    TimeRecordingSettingsEntity,
} from '@data-terminal/shared-models/time-recording-settings';

@Injectable({
    providedIn: 'root',
})
export class SettingsTimeRecordingService {
    readonly #settingsTimeRecordingApiService = inject(SettingsTimeRecordingApiService);

    private static readonly defaultTimeRecordingSettings: TimeRecordingSettingsEntity = {
        helpersTimeRecording: false,
    };

    #timeRecordingSettings: TimeRecordingSettingsEntity = SettingsTimeRecordingService.defaultTimeRecordingSettings;
    readonly #timeRecordingSettings$ = new BehaviorSubject<TimeRecordingSettingsEntity>(this.#timeRecordingSettings);

    public fetchTimeRecordingSettings(): Observable<TimeRecordingSettingsEntity | undefined> {
        return this.#settingsTimeRecordingApiService.getTimeRecordingSettings().pipe(
            take(1),
            tap((settings) => {
                this.#overrideTimeRecordingSettings(settings);
            })
        );
    }

    public getTimeRecordingSettings$(): Observable<TimeRecordingSettingsEntity> {
        return this.#timeRecordingSettings$.asObservable();
    }

    public updateTimeRecordingSettings(
        body: TimeRecordingSettings
    ): Observable<TimeRecordingSettingsEntity | undefined> {
        return this.#settingsTimeRecordingApiService.setTimeRecordingSettings(body).pipe(
            take(1),
            tap((settings) => this.#overrideTimeRecordingSettings(settings))
        );
    }

    public getDefaultTimeRecordingSettings(): TimeRecordingSettingsEntity {
        return SettingsTimeRecordingService.defaultTimeRecordingSettings;
    }

    #overrideTimeRecordingSettings(settings: TimeRecordingSettingsEntity | undefined): void {
        this.#timeRecordingSettings = settings ?? SettingsTimeRecordingService.defaultTimeRecordingSettings;
        this.#timeRecordingSettings$.next(this.#timeRecordingSettings);
    }
}
